export default __webpack_public_path__ + "static/media/MLI.71f27b3c.svg";